import '../../../Common.scss';
import '../../Common.scss';
import './CurrentSubscriptions.scss';
import { SubscriptionData } from 'types/billing';
import { ReactComponent as BellIcon } from 'images/icons/Bell.svg';
import Separator from 'components/Separator/Separator';
import { useTranslation, Trans } from 'react-i18next';
import { formatDate } from 'utilities/formatDate';

export const CurrentSubscriptions = ({
  userSubscriptions,
  hasNoActiveSubscriptions,
}: {
  userSubscriptions: SubscriptionData[];
  hasNoActiveSubscriptions: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className='profile-section subscription-section'>
        <div className='profile-section-title'>
          <BellIcon />
          {t('CurrentSubscriptions', { ns: 'billingInformation' })}
        </div>
        {hasNoActiveSubscriptions ? (
          <div className='no-active-subscriptions'>{t('YouHaveNoSubscriptions', { ns: 'billingInformation' })}</div>
        ) : (
          userSubscriptions.map((subscription) => (
            <PlanEntry
              subscription={subscription}
              formattedDate={formatDate(subscription.currentPeriodEnds)}
              expired={Date.now() > Date.parse(subscription.currentPeriodEnds)}
            />
          ))
        )}
        <p className='subscription-contact'>
          <Trans i18nKey='ContactWithBillingAndPaymentRelatedQuestions' ns='billingInformation'>
            Contact <a href='mailto:support@trackman.com'>support@trackman.com</a> with Billing & Payment related questions
          </Trans>
        </p>
      </div>
    </>
  );
};

const PlanEntry = ({
  subscription,
  expired,
  formattedDate,
}: {
  subscription: SubscriptionData;
  expired: boolean;
  formattedDate: string;
}) => {
  const { t } = useTranslation();

  return (
    <div className='plan-info' key={subscription.id}>
      {!(expired || subscription.cancelled) ? (
        <div className='profile-section-title profile-section-title--secondary subscription-details-title'>
          {t('YourCurrentPlan', { ns: 'billingInformation' })}
        </div>
      ) : (
        <div className='profile-section-title profile-section-title--secondary subscription-details-title'>
          {t('YourPlan', { ns: 'billingInformation' })}
        </div>
      )}

      <div className='plan-name'>
        <span className='section-value'>{subscription.planName}</span>
        {expired ? (
          <span className='expiry-info expired'>
            {t('Expired', { ns: 'billingInformation' })}&nbsp;
            {formattedDate}
          </span>
        ) : subscription.cancelled ? (
          <span className='expiry-info cancelled'>{t('Cancelled', { ns: 'billingInformation' })}</span>
        ) : (
          <span className='expiry-info valid'>
            {t('ValidUntil', { ns: 'billingInformation' })}&nbsp;
            {formattedDate}
          </span>
        )}
      </div>
      <Separator />
      <div className='profile-section-title profile-section-title--secondary subscription-details-title'>
        {t('Rate', { ns: 'billingInformation' })}
      </div>
      <span className='section-value'>${subscription.annualRate}</span>
      <Separator />
      <div className='profile-section-title profile-section-title--secondary subscription-details-title'>
        {t('Price', { ns: 'billingInformation' })}
      </div>
      <span className='section-value'>${subscription.price}</span>
      <Separator />
      {subscription.autorenew && !expired && !subscription.cancelled ? (
        <>
          <span className='next-billing'>
            {t('NextBillingDate', { ns: 'billingInformation' })} {formattedDate}
          </span>
          <span className='subscription-contact'>
            {t('CancelSubscriptionInformation', { ns: 'billingInformation' })}&nbsp;
            <a href='mailto:support@trackman.com'>support@trackman.com</a>
          </span>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};
